import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Toaster } from 'react-hot-toast';

import { router } from '@/router';
import { ConfirmDialogProvider } from '@/components/common/ConfirmDialog';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
// Inter als variable Schrift, self-hosted (kein Google-CDN → DSGVO-freundlich).
import '@fontsource-variable/inter';
import '@/index.css';

// ─── TanStack Query Client ──────────────────────────────────────────────────

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5_000,            // 5 Sekunden (passt zum Backend-Cache-TTL)
      retry: 1,                    // Ein Retry bei Fehler
      refetchOnWindowFocus: false, // Kein Auto-Refetch beim Fokuswechsel
    },
  },
});

// ─── App rendern ────────────────────────────────────────────────────────────

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Root-Element #root nicht im DOM gefunden.');
}

createRoot(rootElement).render(
  <StrictMode>
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <ConfirmDialogProvider>
          <RouterProvider router={router} />
        </ConfirmDialogProvider>
      <Toaster
        position="bottom-center"
        toastOptions={{
          duration: 3000,
          style: {
            fontSize: '14px',
            borderRadius: '8px',
          },
          success: {
            iconTheme: { primary: '#22c55e', secondary: '#fff' },
          },
          error: {
            duration: 5000,
            iconTheme: { primary: '#ef4444', secondary: '#fff' },
          },
        }}
      />
      </QueryClientProvider>
    </ErrorBoundary>
  </StrictMode>,
);
